import { getSearchFilter } from '@/api/search'
import { getParams } from '@/utils/auth'

const search = {
  state: {
    searchHint: '', // 搜索底纹
    listCatalogName: null, // 分类筛选条目
    listTagName: null, // 标签筛选条目
    listCompname: null, // 发布机构筛选条目
    highSearch: null, // 高级搜索条件
    openUrl: '', // 开放平台链接
    dataBase: '' // 数据库名称
  },
  mutations: {
    SET_HIGH_SEARCH (state, data) {
      state.highSearch = data
    },
    SET_SEARCH_HINT (state, data) {
      state.searchHint = data
    },
    SET_CATALOG_LIST (state, data) {
      state.listCatalogName = data
    },
    SET_TAG_LIST (state, data) {
      state.listTagName = data
    },
    SET_COMPNAME_LIST (state, data) {
      state.listCompname = data
    },
    SET_OPEN_URL (state, data) {
      state.openUrl = data
    },
    SET_DATA_BASE (state, data) {
      state.dataBase = data
    }
  },
  actions: {
    GetSearchFilter ({ commit }) {
      return new Promise((resolve, reject) => {
        getSearchFilter({
          database: getParams('database') ? decodeURIComponent(getParams('database')) : null,
          level: getParams('level') || null
        }).then(res => {
          const data = res.data || {}
          commit('SET_CATALOG_LIST', data.listCatalogName)
          let tagItem = data.listTagName.find(v => v.name === '小康人物')
          data.listTagName.splice(data.listTagName.findIndex(v => v.name === '小康人物'), 1)
          let list = data.listTagName.map(item => {
            if (item.name !== '小康人物') {
              return item
            } else {
              return {
                ...item,
                children: [
                  ...item.children,
                  ...tagItem.children
                ]
              }
            }
          })
          commit('SET_TAG_LIST', list)
          // commit('SET_TAG_LIST', data.listTagName)
          data.listCompnameTree.forEach(item => {
            item.name = item.compname
            item.id = item.compid
            item.children.forEach(city => {
              city.name = city.compname
              city.id = city.compid
              city.children.forEach(county => {
                county.name = county.compname
                county.id = county.compid
                county.children = null
              })
            })
          })
          commit('SET_COMPNAME_LIST', data.listCompnameTree)

          commit('SET_OPEN_URL', data.ctxLoginUrl)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default search
